module.exports = __webpack_public_path__ + "img/tb.0aed10a.png";